import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Image from "next/image"
import { Link } from "utils"
import { getUmbracoMediaUrl } from "utils/getUmbracoMediaUrl"
import { Desktop, Mobile } from "../../common/bit/MediaQueries"

const StyledLayout = styled.div`
  display: flex;

  align-items: center;
  justify-content: center;
  padding-bottom: 24px;
  border-bottom: 1px solid white;
  ${(p) => p.theme.breakpoints.up("md")} {
    justify-content: space-between;
  }
`

const StyledGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: max-content;
    flex-direction: row;
    gap: 64px;
  }
`

const IconsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: max-content;
    text-align: unset;
    gap: 20px;
  }
`

const IconsRows = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
  ${(p) => p.theme.breakpoints.up("md")} {
    justify-content: unset;
  }
`

const IconLink = styled(Link)`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 48px;
  border: 1px solid white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  .default-icon {
    opacity: 1;
    transition: opacity 0.3s;
  }

  .hover-icon {
    opacity: 0;
    position: absolute;
    transition: opacity 0.3s;
  }

  &:hover {
    background-color: white;
    .default-icon {
      opacity: 0;
    }
    .hover-icon {
      opacity: 1;
    }
  }
  &:focus-visible {
    border: 1px dashed white;
    outline-offset: 2px;
    outline: 2px solid black;
  }
`

export default function FooterIcons({
  logo,
  socialItems,
  socialTitle,
  appDownloadItems,
  appDownloadText,
}: {
  logo?: string
  socialItems: {
    link: string
    icon: { url: string; altText: string }
    iconHover: string
  }[]
  socialTitle: string
  appDownloadItems: {
    link: string
    icon: { url: string; altText: string }
    iconHover: string
  }[]
  appDownloadText: string
}) {
  return (
    <StyledLayout>
      <Desktop>
        <Image
          width={64}
          height={64}
          src={getUmbracoMediaUrl(logo) || ""}
          alt="logo"
        />
      </Desktop>
      <StyledGroupContainer>
        <IconsContainer>
          <Desktop>
            <Typography variant="body3" color="white" component={"h4"}>
              {socialTitle}
            </Typography>
          </Desktop>
          <Mobile>
            <Typography variant="body2" color="white" component={"h4"}>
              {socialTitle}
            </Typography>
          </Mobile>
          <IconsRows>
            {socialItems.map((el, i) => {
              return (
                <IconLink key={i} href={el.link || ""} target="_blank">
                  <Image
                    width={24}
                    height={24}
                    src={getUmbracoMediaUrl(el.icon.url)}
                    alt={el.icon.altText || "social"}
                    className="default-icon"
                  />
                  <Image
                    width={24}
                    height={24}
                    src={getUmbracoMediaUrl(el.iconHover)}
                    alt={el.icon.altText || "social"}
                    className="hover-icon"
                  />
                </IconLink>
              )
            })}
          </IconsRows>
        </IconsContainer>
        <IconsContainer>
          <Desktop>
            <Typography variant="body3" color="white" component={"h4"}>
              {appDownloadText}
            </Typography>
          </Desktop>
          <Mobile>
            <Typography variant="body2" color="white" component={"h4"}>
              {appDownloadText}
            </Typography>
          </Mobile>
          <IconsRows>
            {appDownloadItems.map((el, i) => (
              <IconLink key={i} href={el.link || ""} target="_blank">
                <Image
                  width={24}
                  height={24}
                  src={getUmbracoMediaUrl(el.icon.url)}
                  alt={el.icon.altText || "appstore"}
                  className="default-icon"
                />
                <Image
                  width={24}
                  height={24}
                  src={getUmbracoMediaUrl(el.iconHover)}
                  alt={el.icon.altText || "appstore"}
                  className="hover-icon"
                />
              </IconLink>
            ))}
          </IconsRows>
        </IconsContainer>
      </StyledGroupContainer>
    </StyledLayout>
  )
}
